import { useFormContext } from 'react-hook-form';

export function FormErrorsSummary() {
  const { formState } = useFormContext();

  return Object.keys(formState?.errors).length > 0 ? (
    <div className="border border-solid border-grey-mid bg-[hsla(0,100%,50%,0.15)] p-2.5">
      <p className="my-2.5">Please correct these errors:</p>
      <ul className="m-0">
        {Object.keys(formState?.errors).map((key) => (
          <li key={key} className="before:inline before:content-['⚠_']">
            {formState?.errors[key]?.message as string}
          </li>
        ))}
      </ul>
    </div>
  ) : null;
}
